// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"122":"0f661824","141":"a895a8cd","714":"e575b8c9"}[chunkId] + ".chunk.css";
};